import { api } from './api.js';

export interface Paginado<T extends { id: string }> {
  data: T[];
  meta: { total: number; page: number; limit: number };
}

// La API pagina con un tope de 100 por página. Para las vistas que calculan
// totales sobre TODO (CxC, con el histórico del Excel son ~700 entradas) se
// piden todas las páginas y se juntan. `ruta` no lleva `limit` ni `page`.
export async function traerTodasLasPaginas<T extends { id: string }>(ruta: string): Promise<Paginado<T>> {
  const sep = ruta.includes('?') ? '&' : '?';
  const primera = await api.get<Paginado<T>>(`${ruta}${sep}limit=100&page=1`);
  const paginas = Math.ceil(primera.meta.total / primera.meta.limit);
  const resto = await Promise.all(
    Array.from({ length: Math.max(0, paginas - 1) }, (_, i) =>
      api.get<Paginado<T>>(`${ruta}${sep}limit=100&page=${i + 2}`)),
  );
  // Si alguien da de alta un registro mientras se piden las páginas, el
  // corrimiento puede repetir uno entre páginas: se deja una sola copia por id.
  const porId = new Map<string, T>();
  for (const item of [primera, ...resto].flatMap(p => p.data)) porId.set(item.id, item);
  return { data: [...porId.values()], meta: primera.meta };
}
